const translations = {
    applicationDate: 'Application Date',
    scheduledFor: 'Scheduled for {{date}}'
};

export default translations;
